import * as React from "react"
import { Box } from "@mui/material"

import { LIMITS_VIEWS } from "../@constants"
import { CommonIconButton, ListRetailers } from "../../@components"


export default function retailerColumn() {
	return [{
		name: "filterRetailers", label: 'Retailers',
        options: {
            display: 'excluded',
            filterType: "textField",
            customBodyRowRender: (_, row) => {
                const elements = row?.retailers?.length > 0 ? row?.retailers.map(item => item.data.label) : [ ]
                return `${elements}`
            }
        }
	}, {
		name: "retailers", label: 'Retailers',
		options: {
			filter: false,
			setCellProps: () => ({ sx: { maxWidth: 140 } }),
			customBodyRowRenderLite: (value, row) => {

				const retailersToShow = value?.length > 0 ? value.slice(0, 6) : value

				return <Box sx={{ display: 'flex',flexWrap: 'wrap', ml: 1 }}>
                    {!!value && <ListRetailers retailers={retailersToShow} /> }
                    { value?.length > LIMITS_VIEWS.RETAILERS && <CommonIconButton alertSelected={row} />}
                </Box>
			}
		}
	}]
}